import { memo } from "react";
import { formatLegendCountLabel } from "@/components/Map/Legend/format-legend-count-label";
import { LegendItem } from "@/components/Map/LegendItem/LegendItem";
import { cx } from "@/utils/cx";

export interface MapLayerConfig {
	id: string;
	label: string;
	color: string;
	visible: boolean;
	count?: number;
	totalCount?: number;
	/** When true, show a loader in place of the in-viewport count (total count remains visible). */
	countLoading?: boolean;
	onToggle: (visible: boolean) => void;
}

export interface MapLayersLegendProps {
	layers: MapLayerConfig[];
	className?: string;
}

export const MapLayersLegend = memo(function MapLayersLegend({
	layers,
	className,
}: MapLayersLegendProps) {
	return (
		<div
			className={cx(
				"min-w-[200px] rounded-lg bg-white px-3 py-2 shadow-md dark:bg-gray-800/95",
				className,
			)}
		>
			<div className="flex flex-col gap-0">
				{layers.map((layer) => {
					const countLoading = Boolean(layer.countLoading && layer.visible);
					const countLabel = formatLegendCountLabel({
						count: layer.count,
						totalCount: layer.totalCount,
						countLoading,
						visible: layer.visible,
					});
					return (
						<LegendItem
							key={layer.id}
							label={layer.label}
							color={layer.color}
							isSelected={layer.visible}
							onChange={layer.onToggle}
							countLabel={countLabel}
							countLoading={countLoading}
							className="-mx-1 rounded-md px-1 py-1 transition-colors hover:bg-gray-100 focus-visible:bg-gray-100 dark:hover:bg-gray-700/60 dark:focus-visible:bg-gray-700/60"
						/>
					);
				})}
			</div>
		</div>
	);
});
